import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import JumbledSentenceEmbed from '../components/Exercise/JumbledSentenceEmbed';

export default Node.create({
  name: 'jumbledSentence',
  group: 'block',
  atom: true,
  draggable: true,
  addAttributes() {
    return {
      sentences: {
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('sentences');
          try { return data ? JSON.parse(data) : []; } catch { return []; }
        },
        renderHTML: attributes => attributes.sentences
          ? { sentences: JSON.stringify(attributes.sentences) } : {},
      },
      title: {
        default: 'Word Order Exercise',
        parseHTML: element => element.getAttribute('title') || 'Word Order Exercise',
        renderHTML: attributes => attributes.title ? { title: attributes.title } : {},
      },
      level: {
        default: 'B1',
        parseHTML: element => element.getAttribute('level') || 'B1',
        renderHTML: attributes => attributes.level ? { level: attributes.level } : {},
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {},
      },
    };
  },
  parseHTML() {
    return [{ tag: 'div[data-type="jumbled-sentence"]' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'jumbled-sentence' })];
  },
  addNodeView() {
    return ReactNodeViewRenderer(JumbledSentenceEmbed);
  },
  addCommands() {
    return {
      insertJumbledSentenceExercise:
        (attributes) =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs: attributes }),
    };
  },
});
